/**
 * An object containing properties for list events
 */
var ListEvent = /** @class */ (function () {
    function ListEvent() {
    }
    return ListEvent;
}());
export { ListEvent };
//# sourceMappingURL=list-event.js.map